import { module } from 'modujs'
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m)

        // UI
        this.$el = this.el
        this.$items = this.$('item')
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.computeCurrentItem()
    }

    destroy() {
        super.destroy()
    }

    ///////////////
    // Methods
    ///////////////
    computeCurrentItem() {
        this.$items.forEach(($link, index) => {
            $link.classList.remove('is-current')

            if ($link.href == document.location.href) {                  
                $link.classList.add('is-current')
            }
        })
    }
}
